import { PiAsset } from "../../Types/PiAsset";
import type { StopCodingFilterType } from "../OI/redux/stopCoding";

export const STOP_CODING_ASSET_TREE_STORAGE_KEY = "stopCodingAssetTreeExpandedItems";

/** Capabilities that set the stop coding filter, with their menu labels. */
export const STOP_CODING_CAPABILITY_LABELS: { [name: string]: string } = {
    wc: "Workcenter",
    group: "Group",
    machine: "Machine",
};

/**
 * Saved expanded-state id. The root's children are known by their own name, deeper items by their parent's name and
 * theirs. Kept as it was so saved trees still open.
 */
export const stopCodingAssetId = (asset: PiAsset, parent: PiAsset | undefined, depth: number) =>
    depth <= 1 || !parent ? asset.Name : `${parent.Name}/${asset.Name}`;

/**
 * The parent the filter is built from. The root's children never had one, so their group filter falls back to
 * their work center, as it always has.
 */
export const stopCodingFilterParent = (parent: PiAsset | undefined, depth: number) => (depth <= 1 ? undefined : parent);

export interface StopCodingFilterSelection {
    type: Exclude<StopCodingFilterType, "all">;
    /** What the stops are queried by. */
    value: string;
    /** Shown above the charts and saved with the filter. */
    displayValue: string;
    /** Display name for the legacy Redux filter. */
    legacyDisplayName: string;
}

/** The filter a capability of an asset selects, or undefined for capabilities that don't filter. */
export function getStopCodingFilter(capabilityName: string, item: PiAsset, parent: PiAsset | undefined): StopCodingFilterSelection | undefined {
    if (capabilityName === "wc") {
        return {
            type: "workcenter",
            value: item.Name,
            displayValue: item.Name,
            legacyDisplayName: `${item.Name} - ${item.Description}`,
        };
    }

    if (capabilityName === "group") {
        const workcenter = parent?.Name || item.WorkCenter;
        const groupValue = `${workcenter}-${item.Name}`;
        return {
            type: "group",
            value: groupValue,
            displayValue: groupValue,
            legacyDisplayName: `${parent?.Name} - ${item?.Name}`,
        };
    }

    if (capabilityName === "machine") {
        return {
            type: "machine",
            value: item.Name,
            displayValue: item.WorkCenter + "    " + item.Name + "-" + item.Alias,
            legacyDisplayName: parent?.Name && item.WorkCenter ? `${item.WorkCenter}-${parent.Name} ${item.Name}` : item.Name,
        };
    }

    return undefined;
}
